/**
 * Shared Sentry event shaping for web (@sentry/react) and mobile (@sentry/react-native).
 * Keeps PII redaction consistent via ErrorSanitizer — apps only supply their Sentry SDK for init/capture.
 */
import { errorSanitizer } from "../security/ErrorSanitizer.js";
const ETH_ADDRESS_LIKE = /0x[a-fA-F0-9]{40,}/g;
export function redactForMonitoring(text) {
    return errorSanitizer.redact(text);
}
export function sanitizeMonitoringValue(value) {
    return errorSanitizer.sanitizeValue(value);
}
/**
 * Mutates and returns the same event instance (Sentry beforeSend convention).
 * Typed loosely so @sentry/react and @sentry/react-native ErrorEvent both accept.
 */
export function sanitizeSentryEvent(event, options) {
    const ev = event;
    const stripHex = options?.stripLongHexAddresses ?? true;
    if (ev.exception?.values) {
        for (const exception of ev.exception.values) {
            if (exception?.value) {
                let value = errorSanitizer.redact(exception.value);
                if (stripHex) {
                    value = value.replace(ETH_ADDRESS_LIKE, "[ADDRESS]");
                }
                exception.value = value;
            }
        }
    }
    if (ev.message) {
        let message = errorSanitizer.redact(ev.message);
        if (stripHex) {
            message = message.replace(ETH_ADDRESS_LIKE, "[ADDRESS]");
        }
        ev.message = message;
    }
    if (ev.extra) {
        ev.extra = errorSanitizer.sanitizeValue(ev.extra);
    }
    if (ev.breadcrumbs) {
        for (const breadcrumb of ev.breadcrumbs) {
            if (breadcrumb.message) {
                breadcrumb.message = errorSanitizer.redact(breadcrumb.message);
            }
            if (breadcrumb.data) {
                breadcrumb.data = errorSanitizer.sanitizeValue(breadcrumb.data);
            }
        }
    }
    if (ev.tags) {
        ev.tags = errorSanitizer.sanitizeValue(ev.tags);
    }
    return event;
}
export function sanitizeErrorMonitoringContext(context) {
    if (!context)
        return undefined;
    return errorSanitizer.sanitizeValue(context);
}
